import type { ReactNode } from 'react';

export const symbol_sensor_window: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-80q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h520q24 0 42 18t18 42v680q0 24-18 42t-42 18H220Zm0-430h190v-40h140v40h190v-310H220v310Zm0 60v310h520v-310H220Zm0 310h520-520Z"
		/>
	</svg>
);
